import React, { useState, useContext, useEffect, useRef } from 'react';
import { ProjectContext } from '../context/ProjectContext';

export function Nav() {
  const nameInput = useRef(null);
  const hide = useRef(null);
  const { projects } = useContext(ProjectContext);
  const [name, setName] = useState('Me');

  useEffect(() => {
    const data = localStorage.getItem('name');
    if (data) {
      setName(JSON.parse(data))
    }
  }, [])
  
  useEffect(() => {
    localStorage.setItem('name', JSON.stringify(name))
  })

  useEffect(() => {
    document.title = (name === "Me" ? "My" : name+"'s") + " Knit Tracker | wooly.";
    hide.current.textContent = nameInput.current.value;
    nameInput.current.style.width = (hide.current.offsetWidth + 20)+ "px";
  })

  return(
    <nav>
      <h1>wooly.</h1>
      <p id="project-count">{projects.length} open {projects.length === 1 ? "project" : "projects"}</p>
      <span id="name">
        <p>Knitted by </p>
        <span id="hide" ref={hide}></span>
          <input id="txt" value={name} ref={nameInput} onChange={(e) => setName(e.target.value)}></input>
        <p>.</p>
      </span>
    </nav>
  )
}